import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpDefinitionListComponent from './adpDefinitionList.component';

let adpDefinitionListModule = angular.module('adpDefinitionList', [
  uiRouter
])

.component('adpDefinitionList', adpDefinitionListComponent)

.name;

export default adpDefinitionListModule;



// WEBPACK FOOTER //
// ./src/app/components/adpDefinitionList/adpDefinitionList.js